import { RemoteChangePersonPassword } from 'data/usecases';
import { makeApiUrlPerson } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteChangePersonPassword =
  (): RemoteChangePersonPassword => {
    return new RemoteChangePersonPassword(
      makeApiUrlPerson(),
      makeAxiosHttpClient(),
    );
  };
